import { render, staticRenderFns } from "./DietPrice.vue?vue&type=template&id=5200087e&"
import script from "./DietPrice.vue?vue&type=script&lang=js&"
export * from "./DietPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports